import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://gwjrpdbciuggvtjykgdb.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd3anJwZGJjaXVnZ3Z0anlrZ2RiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ4ODM4MTksImV4cCI6MjA5MDQ1OTgxOX0.9xOSSzi-8DDvqUzPc_pUsS6lVYNP0otnd5ILGyHNlF8'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables')
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})